const trexEnv = process.env.NEXT_PUBLIC_CLIENT_ENV;

export const serverUrl = {
  beta: "https://api.trex.beta.dipbit.xyz",
  prod: "https://api.trex.xyz",
  dev: "https://api.trex.dev.dipbit.xyz",
} as const;

export const anchorServerUrl = {
  beta: "https://anchor.trex.beta.dipbit.xyz",
  prod: "https://anchor.trex.xyz",
  dev: "https://anchor.trex.dev.dipbit.xyz",
} as const;

export const getServerUrl = () => {
  if (trexEnv === "beta") {
    return serverUrl.beta;
  }

  if (trexEnv === "prod") {
    return serverUrl.prod;
  }

  return serverUrl.dev;
};

export const getAnchorServerUrl = () => {
  if (trexEnv === "beta") {
    return anchorServerUrl.beta;
  } else if (trexEnv === "prod") {
    return anchorServerUrl.prod;
  } else {
    return anchorServerUrl.dev;
  }
};
